import Vue from 'vue';
import Vuex from 'vuex';
import storage from '../utils/storage';
import { getUserInfo } from '../api/api'


// 安装插件
Vue.use(Vuex);

// 创建 store 对象
const store = new Vuex.Store({
    namespaced: false, // 根据实际情况决定是否需要命名空间

    // 存放数据
    state: {
        QYID: 190,  // 固定的qiyd
        USERINFO: storage.get('USERINFO') || null, // 用户信息
        OPENID: storage.get('OPENID') || null, // 获取开放id

        // 当前国家信息
        COUNTRY: storage.get('COUNTRY') ? storage.get('COUNTRY') : {},
        // 当前语言
        LANGUAGE: storage.get('language') || 'CN'
    },

    // 修改状态的方法
    mutations: {
        updateUserInfo(state, data) {
            storage.set('USERINFO', data);
            state.USERINFO = data;
        },

        updateOpenid(state, data) {
            storage.set('OPENID', data);
            state.OPENID = data;
        },

        updateCountry(state, data) {
            storage.set('COUNTRY', data);
            state.COUNTRY = data;
        },
        // 更新语言
        updateLanguage(state, language) {
            storage.set('language', language);
            state.LANGUAGE = language;
        }
    },

    // 异步方法
    actions: {
        async fetchUserInfo({ commit }, openid) {
            try {
                const response = await getUserInfo({ openid })
                if (response.id) {
                    commit('updateUserInfo', response);
                } else {
                    commit('updateOpenid', '');
                    commit('updateUserInfo', '');
                }
            } catch (error) {
                console.error("获取用户信息失败", error);
            }
        },

        // 可以在此添加更多异步操作
        updateOpenid({ commit }, openid) {
            commit('updateOpenid', openid);
        },

        // 可以在此添加更多异步操作
        updateCountry({ commit }, obj) {
            commit('updateCountry', obj);
        },
        // 更新语言
        updateLanguage({ commit }, language) {
            commit('updateLanguage', language);
        }
    },
    // 计算属性
    getters: {
        currentLocale: state => {
            return state.LANGUAGE === 'CN' ? 'zh' : 'en';
        }
    }
});

export default store;